import {keyCodes} from '../../../utility/js/utils';

(function () {
    const tooltip = {
        $trigger: null,
        $target: null,
        vPort: 'screen-md',
        isMobile: false,
        init: function () {
            tooltip.$trigger = $('body').find('.tooltip');
            tooltip.$target = tooltip.$trigger.find('.tooltip__body');
            tooltip.control();
        },
        control: function () {
            $(document).on(tooltip.vPort + '-on', function () {
                tooltip.isMobile = true;
                tooltip.on.hideOnChangeView(tooltip.isMobile);
                tooltip.init();
            });
            $(document).on(tooltip.vPort + '-off', function () {
                tooltip.isMobile = false;
                tooltip.on.hideOnChangeView(tooltip.isMobile);
                tooltip.init();
            });
            $('body').on('click focusin focusout keydown', '.tooltip', function (e) {
                const shouldPreventDefault = e.keyCode !== keyCodes.TAB;
                shouldPreventDefault && e.preventDefault();
                e.stopImmediatePropagation();
                let $this = $(this),
                    $target = $this.find('.tooltip__body');

                if ($this.is(':focusable')) {
                    switch (e.type) {
                        case 'focusin':
                            $target.addClass('js--focused');
                            tooltip.on.show($this, $target);
                            tooltip.setPosition($this);
                            break;
                        case 'focusout':
                            $target.removeClass('js--focused');
                            $this.hasClass('tooltip__metrics') || tooltip.on.hide($this, $target);
                            break;
                        case 'click':
                            tooltip.on.click($this, $target);
                            break;
                        case 'keydown':
                            if (e.keyCode === keyCodes.ESCAPE) {
                                $target.removeClass('js--focused');
                                tooltip.on.hide($this, $target);
                                $target.setAttribute('aria-expanded', false);
                            } else if (e.keyCode === keyCodes.RETURN || e.keyCode === keyCodes.SPACE) {
                                tooltip.on.click($this, $target);
                                $target.setAttribute('aria-expanded', true);
                            } else if (e.keyCode === keyCodes.TAB && e.shiftKey) {
                                $target.removeClass('js--focused');
                                tooltip.on.hide($this, $target);
                            }
                            break;
                    }
                } else {
                    if ($target.hasClass('js--open') && !tooltip.isMobile) {
                        tooltip.on.hide($this, $target);
                    } else {
                        tooltip.on.show($this, $target);
                        tooltip.setPosition($this);
                    }
                }
            });
            if (tooltip.$target.length && tooltip.$target[0]?.closest('.tooltip__metrics')) {
                tooltip.$target[0]?.addEventListener('focusout', e => {
                    const $this = $(e.target).closest('.tooltip__metrics'),
                        $target = $this.find('.tooltip__body');
                    tooltip.on.hide($this, $target);
                });
                tooltip.$target[0]?.addEventListener('keydown', e => {
                    if (e.keyCode === keyCodes.RETURN || e.keyCode === keyCodes.SPACE) {
                        window.location.href = e.target.href;
                    }
                });
            }

            $(window).on('resize', function () {
                tooltip.setPosition(tooltip.$trigger);
            });
            $(window).on('scroll', function () {
                tooltip.on.checkToHide();
            });
            $(document)
                .find('.tab__content.sticko__child')
                .on('scroll', function () {
                    tooltip.on.checkToHide();
                });
            $(document).on('click', function (e) {
                if (
                    !$(e.target).is(tooltip.$trigger) &&
                    !$(e.target).parents().is(tooltip.$trigger) &&
                    tooltip.$target.hasClass('js--open')
                ) {
                    tooltip.on.hide(tooltip.$trigger, tooltip.$target);
                }
            });
            if (tooltip.$trigger.length) {
                tooltip.$trigger[0]?.querySelector('a')?.addEventListener('mousedown', e => {
                    if (e.button === keyCodes.leftClick) {
                        window.location.href = e.target.href;
                    }
                });
            }
        },
        setPosition: function ($element) {
            if ($element.length) {
                let $this = $element,
                    $target = $this.find('.tooltip__body'),
                    eleBounding = $this[0].getBoundingClientRect(),
                    windowWidth = $(window).width(),
                    availableWidth = windowWidth - (eleBounding.right + 20);

                if (tooltip.isMobile) {
                    let wSlideTop = $target.closest('.w-slide').length ? $target.closest('.w-slide').css('top') : 0,
                        mobileTop = eleBounding.top + 20 - wSlideTop;

                    $target.css({
                        top: mobileTop,
                        right: 'toRem(20)',
                        left: 'toRem(20)',
                        width: 'auto',
                    });
                } else {
                    if (availableWidth < $target.innerWidth()) {
                        $target.addClass('js--inverse').css({
                            top: eleBounding.top - $target.outerHeight() / 2 + $this.height() / 2,
                            left: eleBounding.left - 30 - $target.width(),
                        });
                    } else {
                        $target.removeClass('js--inverse').css({
                            top: eleBounding.top - $target.outerHeight() / 2 + $this.height() / 2,
                            left: eleBounding.right + 20,
                        });
                    }
                }
            }
        },
        on: {
            show: function ($this, $target) {
                let tooltipBody = $('.tooltip__body'),
                    tooltipBodyCount = tooltipBody.length;

                $target.addClass('js--open');
                $this.attr('aria-expanded', 'true');
                if (tooltipBodyCount > 1) {
                    tooltipBody.not($target).removeClass('js--open');
                }
            },
            hide: function ($this, $target) {
                $target.removeClass('js--open js--inverse').removeAttr('style');
                $this.attr('aria-expanded', 'false');
            },
            checkToHide: function () {
                if (tooltip.$trigger.length && tooltip.$target.hasClass('js--open')) {
                    tooltip.$trigger.trigger('blur');
                    tooltip.$target.removeClass('js--open');
                }
            },
            hideOnChangeView: function (isMobileVal) {
                tooltip.isMobile = isMobileVal;
                $(document).find('.tooltip__body').removeClass('js--open js--inverse').removeAttr('style');
            },
            click: function ($this, $target) {
                if ($target.hasClass('js--focused') && $target.hasClass('js--open')) {
                    tooltip.on.show($this, $target);
                    tooltip.setPosition($this);
                    $target.removeClass('js--focused');
                } else if (!$target.hasClass('js--focused') && !$target.hasClass('js--open')) {
                    tooltip.on.show($this, $target);
                    tooltip.setPosition($this);
                } else {
                    tooltip.on.hide($this, $target);
                }
            },
        },
    };
    UX.tooltip = tooltip;
})();
